import { render, staticRenderFns } from "./questionBank.vue?vue&type=template&id=00b7c59a"
import script from "./questionBank.vue?vue&type=script&lang=js"
export * from "./questionBank.vue?vue&type=script&lang=js"
import style0 from "./questionBank.vue?vue&type=style&index=0&id=00b7c59a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports